angular.module('core')
  .config(['portal', portal => {
    const year = new Date().getFullYear();
    portal.copyright = `© ${year} ${portal.name}`;
  }]);
